// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared styling for the "move media" select mode: selectable overlays + bottom action bar. */

.move_selectable__H-ghI {
    cursor: pointer;
    user-select: none;
    -webkit-user-select: none;
    -webkit-touch-callout: none;
}

.move_selectableBox__8pV\\+E {
    position: relative;
    height: 100%;
    box-sizing: border-box;
    border: 3px solid transparent;
    border-radius: 6px;
    overflow: hidden;
    transition: border-color 120ms ease, transform 120ms ease;
}

.move_selected__TjAMs {
    border-color: var(--mantine-color-blue-6);
    transform: scale(0.96);
}

.move_check__Ta23F {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: var(--mantine-color-blue-6);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}

.move_checkEmpty__\\+Bs9Z {
    background: rgba(0, 0, 0, 0.35);
    border: 2px solid white;
}

.move_time__6EBN- {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
    color: white;
    font-size: 10px;
    padding: 12px 4px 4px;
    pointer-events: none;
    text-align: center;
}

.move_actionBar__JWiEg {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    border-top: 1px solid var(--mantine-color-gray-3);
    padding: 10px 16px;
    z-index: 100;
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.05);
    padding-bottom: calc(10px + env(safe-area-inset-bottom));
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Galeries/Detail/Move/move.module.css"],"names":[],"mappings":"AAAA,8FAA8F;;AAE9F;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,yDAAyD;AAC7D;;AAEA;IACI,yCAAyC;IACzC,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uCAAuC;IACvC,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,wCAAwC;AAC5C;;AAEA;IACI,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,oEAAoE;IACpE,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,iDAAiD;IACjD,kBAAkB;IAClB,YAAY;IACZ,2CAA2C;IAC3C,wDAAwD;AAC5D","sourcesContent":["/* Shared styling for the \"move media\" select mode: selectable overlays + bottom action bar. */\n\n.selectable {\n    cursor: pointer;\n    user-select: none;\n    -webkit-user-select: none;\n    -webkit-touch-callout: none;\n}\n\n.selectableBox {\n    position: relative;\n    height: 100%;\n    box-sizing: border-box;\n    border: 3px solid transparent;\n    border-radius: 6px;\n    overflow: hidden;\n    transition: border-color 120ms ease, transform 120ms ease;\n}\n\n.selected {\n    border-color: var(--mantine-color-blue-6);\n    transform: scale(0.96);\n}\n\n.check {\n    position: absolute;\n    top: 6px;\n    right: 6px;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    background: var(--mantine-color-blue-6);\n    color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    pointer-events: none;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);\n}\n\n.checkEmpty {\n    background: rgba(0, 0, 0, 0.35);\n    border: 2px solid white;\n}\n\n.time {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);\n    color: white;\n    font-size: 10px;\n    padding: 12px 4px 4px;\n    pointer-events: none;\n    text-align: center;\n}\n\n.actionBar {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: white;\n    border-top: 1px solid var(--mantine-color-gray-3);\n    padding: 10px 16px;\n    z-index: 100;\n    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.05);\n    padding-bottom: calc(10px + env(safe-area-inset-bottom));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectable": `move_selectable__H-ghI`,
	"selectableBox": `move_selectableBox__8pV+E`,
	"selected": `move_selected__TjAMs`,
	"check": `move_check__Ta23F`,
	"checkEmpty": `move_checkEmpty__+Bs9Z`,
	"time": `move_time__6EBN-`,
	"actionBar": `move_actionBar__JWiEg`
};
export default ___CSS_LOADER_EXPORT___;
